// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { SHAREPOINT_WORKBOOK_CONTRACT_VERSION_V2 } from 'constants/SharepointWorkbookContract';

export type PostSharepointWriteNumberParams = {
  templateId: string;
  url: string;
  worksheet: string;
  gridRowIndices: number[];
  numberValue: string;
};

export async function postSharepointWriteNumber(
  params: PostSharepointWriteNumberParams
): Promise<void> {
  await axios.post('/sharepoint/workbooks/load-id-writeback', {
    contractVersion: SHAREPOINT_WORKBOOK_CONTRACT_VERSION_V2,
    templateId: params.templateId,
    url: params.url,
    worksheet: params.worksheet,
    gridRowIndices: params.gridRowIndices,
    numberValue: params.numberValue,
  });
}
